export const ORDERS_ON_CHART_YELLOW = '#FFA500'

export enum PositionComponentTypes {
    REVERSE_BTN = 'REVERSE_BTN',
    TARGET_PRICE_BTN = 'TARGET_PRICE_BTN',
    STOPLOSS_BTN = 'STOPLOSS_BTN',
    QUANTITY_BTN = 'QUANTITY_BTN',
    PRICE_BTN = 'PRICE_BTN',
    CANCEL_BTN = 'CANCEL_BTN',
    MODIFY_ORDER_LINE = 'MODIFY_ORDER_LINE',
    DISCARD_BTN = 'DISCARD_BTN',
    CONFIRM_BTN = 'CONFIRM_BTN',
    PRODUCT = 'PRODUCT',
    ALERT = 'ALERT'
}
